import { MMKV } from 'react-native-mmkv';

export const persistedStorage = new MMKV();
